import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Dropdown, NavItem } from 'react-materialize';
import { CSVDownload } from 'react-csv';
import './style.css';
import * as actions from '../../actions';

class Header extends Component {
  componentWillMount() {
    this.props.history.listen(location => {
      if (location.pathname !== this.props.location.pathname) {
        this.props.location.pathname = location.pathname;
        this.forceUpdate();
      }
    });
  }

  constructor(props) {
    super(props);

    this.renderSiteDropdown       = this.renderSiteDropdown.bind(this);
    this.renderSwitchSiteDropdown = this.renderSwitchSiteDropdown.bind(this);
    this.renderLogout             = this.renderLogout.bind(this);
    this.renderProfileDropdown    = this.renderProfileDropdown.bind(this);
    this.renderUnsubscribeModal   = this.renderUnsubscribeModal.bind(this);
    this.renderExportData         = this.renderExportData.bind(this);
  }

  handleToken(tokenObj, interval) {
    this.props.handleStripeToken(tokenObj, interval);
  }

  renderSwitchSiteDropdown() {
    const { pathname } = this.props.location;
    const trigger = () => <a className="navbar-switch-sites" href="#sites">Switch site</a>;

    if (pathname !== '/dashboard') return null;

    return (
      <Dropdown className="switch-site-dropdown" trigger={trigger()}>
        {this.renderSiteDropdown()}
      </Dropdown>
    )
  }

  renderLogout() {
    const { auth, error } = this.props;

    if (error) return <li key="4"><Link to="/dashboard" onClick={this.props.resetErrors}>Logout</Link></li>;
    if (auth) return <li className="logout-button" key="4"><a href="/api/logout">Logout</a></li>;

    return null;
  }

  renderSubscription() {
    const { bypass, subscription } = this.props.auth;

    const handleOnClick = e => {
      e.preventDefault();

      const { $ } = window;
      // Initialize modal first
      $('#unsubscribe-modal').modal();
      $('#unsubscribe-modal').modal('open');
    };

    // User doesn't need subscription; part of friends/family plan
    if (bypass) return null;

    // Logic for when user is not subscribed
    if (!subscription) {
      return this.renderSubscribeLink();
    }

    return <NavItem onClick={handleOnClick} className="unsubscribe-link-nav">Unsubscribe</NavItem>
  }

  renderExportData() {
    const { fetchExportCsv, startDate, endDate, country, device } = this.props;
    const { subscription, bypass } = this.props.auth;

    // Not available for the user
    if(!subscription && !bypass) return null;

    const handleOnClick = e => {
      e.preventDefault();
      fetchExportCsv({ startDate, endDate, country, device });
    }

    return <NavItem onClick={handleOnClick}>Export Data</NavItem>
  }

  renderProfileDropdown() {
    const trigger = () => <a className="navbar-menu" href="#sites">Menu</a>;

    return (
      <Dropdown className="custom-dropdown" trigger={trigger()}>
        {this.renderLogout()}
        {this.renderExportData()}
        <NavItem divider />
        {this.renderSubscription()}
      </Dropdown>
    )
  }

  renderContent() {
    switch (this.props.auth) {
      case null:
        return;
      case false:
        return <li key="1"><a href="/auth/google">Login with Google</a></li>;
      default:
        return [
          <li key="1">{this.renderProfileDropdown()}</li>,
          <li key="2">{this.renderSwitchSiteDropdown()}</li>,
        ]
    }
  }

  renderSiteDropdown() {
    const { sites } = this.props;
    const handleOnClick = (e, siteUrl) => {
      e.preventDefault();
      this.props.resetFetchExport();
      this.props.selectSite(siteUrl);
    }

    if (!sites) return;

    return sites.map(siteUrl => {
      return (
        <li key={siteUrl}>
          <Link key={siteUrl} className="collection-item" to="" onClick={e => handleOnClick(e, siteUrl)}>
            {siteUrl}
          </Link>
        </li>
      );
    });
  }

  renderUnsubscribeModal() {
    const modalButtonClass = "modal-close waves-effect waves-green btn-flat";
    const { subscription } = this.props.auth;
    const handleOnClick = e => {
      e.preventDefault();
      this.props.unsubscribe(subscription);
    };

    return <div id="unsubscribe-modal" className="modal">
      <div className="modal-content">
        <h4>Are you sure you want to unsubscribe?</h4>
        <p>You will only have access a maximum of 10 pages per site.</p>
        <p>If you accidentally unsubscribe and subscribe again within the same month you will be charged twice!</p>
      </div>
      <div className="modal-footer">
        <a href="#!" className={modalButtonClass}>Keep supporting</a>
        <Link to="/#unsubscribe" className={`${modalButtonClass} unsubscribe-link-modal`} onClick={handleOnClick}>
          Unsubscribe
        </Link>
      </div>
    </div>
  }

  renderCSVDownload() {
    const { exportData } = this.props;
    return exportData.length > 0 ? <CSVDownload data={exportData} target="_self" /> : null;
  }

  renderSubscribeLink() {
    const handleOnClick = e => {
      e.preventDefault();

      const { $ } = window;
      // Initialize modal first
      $('#subscribe-modal').modal();
      $('#subscribe-modal').modal('open');
    };

    return (
      <li><a onClick={handleOnClick} href="#subscribe/cta?location=header" className="header-subscribe-cta">Subscribe now</a></li>
    )
  }

  render() {
    return (
      <nav className="row z-depth-1">
        { this.renderCSVDownload() }
        <div className="nav-wrapper">
          <Link to="/" className="left col s3 m2 l2">Page Outil</Link>
          <ul className="right offset-s6">{this.renderContent()}</ul>
        </div>

        {this.renderUnsubscribeModal()}
      </nav>
    );
  }
}

function mapStateToProps({ auth, sites, startDate, endDate, exportData, error, country, device }) {
  return { auth, sites, startDate, endDate, exportData, error, country, device };
}

export default withRouter(connect(mapStateToProps, actions)(Header));



// WEBPACK FOOTER //
// ./src/components/Global/Header.js